import { render } from "./TestTerm.vue?vue&type=template&id=7fbbbb9e&scoped=true"
import script from "./TestTerm.vue?vue&type=script&lang=js"
export * from "./TestTerm.vue?vue&type=script&lang=js"

import "./TestTerm.vue?vue&type=style&index=0&id=7fbbbb9e&scoped=true&lang=css"

import exportComponent from "/builds/Xpansiv/evo/DataPipeline/DataPipeline.Evolve.Web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fbbbb9e"]])

export default __exports__